import React from 'react';
import axios from 'axios';
import { Button, Form, Segment, Input } from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class SemesterInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionalCoursesECTSMin: '',
            optionalCoursesECTSMax: '',
            optionalCoursesNumberMin: '',
            optionalCoursesNumberMax: '',

            optionalCoursesECTSMinErr: false,
            optionalCoursesECTSMaxErr: false,
            optionalCoursesNumberMinErr: false,
            optionalCoursesNumberMaxErr: false,
        };
        this.saveSemesterInfo = this.saveSemesterInfo.bind(this);
    }

    saveSemesterInfo(
        optionalCoursesECTSMin,
        optionalCoursesECTSMax,
        optionalCoursesNumberMin,
        optionalCoursesNumberMax
    ) {
        let studyProgramSemesterId = this.props.sPsemesterId;
        let optlock = this.props.semesterOptlock;
        let id = this.props.semesterId;

        let semesterObj = {
            optionalCoursesECTSMin,
            optionalCoursesECTSMax,
            optionalCoursesNumberMin,
            optionalCoursesNumberMax,
            studyProgramSemesterId,
            optlock,
            id
        };

        if (!optionalCoursesECTSMin || !optionalCoursesECTSMax || !optionalCoursesNumberMin || !optionalCoursesNumberMax || !studyProgramSemesterId) {
            toast('Niste unijeli sva obavezna polja!');
            if (!optionalCoursesECTSMin) { this.setState({ optionalCoursesECTSMinErr: true }); } else { this.setState({ optionalCoursesECTSMinErr: false }); }
            if (!optionalCoursesECTSMax) { this.setState({ optionalCoursesECTSMaxErr: true }); } else { this.setState({ optionalCoursesECTSMaxErr: false }); }
            if (!optionalCoursesNumberMin) { this.setState({ optionalCoursesNumberMinErr: true }); } else { this.setState({ optionalCoursesNumberMinErr: false }); }
            if (!optionalCoursesNumberMax) { this.setState({ optionalCoursesNumberMaxErr: true }); } else { this.setState({ optionalCoursesNumberMaxErr: false }); }
            if (!studyProgramSemesterId) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
        } else if (parseInt(optionalCoursesECTSMin,10) < 0 || parseInt(optionalCoursesECTSMax,10) < 0 || parseInt(optionalCoursesNumberMin,10) < 0 || parseInt(optionalCoursesNumberMax,10) < 0) {
            toast('Vrijednosti moraju biti pozitivne!');
            this.setState({
                optionalCoursesECTSMinErr: true,
                optionalCoursesECTSMaxErr: true,
                optionalCoursesNumberMinErr: true,
                optionalCoursesNumberMaxErr: true
            });
        } else if (parseInt(optionalCoursesECTSMin,10) > parseInt(optionalCoursesECTSMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesECTSMinErr: true,
                optionalCoursesECTSMaxErr: true
            });
        } else if (parseInt(optionalCoursesNumberMin,10) > parseInt(optionalCoursesNumberMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesNumberMinErr: true,
                optionalCoursesNumberMaxErr: true
            });
        } else {
            axios.put('study-programs/semesters/', { ...semesterObj })
                .then(res => {
                    this.props.saveSemesterInfo();
                })
                .catch(err => {
                    toast('Došlo je do greške! Dodavanje informacija o semestru nije uspjelo.');
                });
        }
    }

    render() {
        return (
            <Segment clearing>
                <Form noValidate>
                    <Form.Group widths="equal">
                        <Form.Field
                            required
                            error={this.state.optionalCoursesECTSMinErr}
                            control={Input}
                            label="Minimalan broj ECTS bodova za izborne predmete"
                            type="number"
                            min={1}
                            value={this.state.optionalCoursesECTSMin}
                            onChange={(e) => this.setState({ optionalCoursesECTSMin: e.target.value })}
                            name="optionalCoursesECTSMin"
                            placeholder="Unesite minimalan broj ECTS bodova"
                        />
                        <Form.Field
                            required
                            error={this.state.optionalCoursesECTSMaxErr}
                            control={Input}
                            label="Maksimalan broj ECTS bodova za izborne predmete"
                            type="number"
                            value={this.state.optionalCoursesECTSMax}
                            onChange={(e) => this.setState({ optionalCoursesECTSMax: e.target.value })}
                            name="optionalCoursesECTSMax"
                            placeholder="Unesite maksimalan broj ECTS bodova"
                            min={1}
                        />
                    </Form.Group>
                    <Form.Group widths="equal">

                        <Form.Field
                            required
                            error={this.state.optionalCoursesNumberMinErr}
                            control={Input}
                            label="Minimalan broj izbornih predmeta"
                            type="number"
                            value={this.state.optionalCoursesNumberMin}
                            onChange={(e) => this.setState({ optionalCoursesNumberMin: e.target.value })}
                            name="optionalCoursesNumberMin"
                            placeholder="Unesite minimalan broj izbornih predmeta"
                            min={1}
                        />
                        <Form.Field
                            required
                            error={this.state.optionalCoursesNumberMaxErr}
                            control={Input}
                            label="Maksimalan broj izbornih predmeta"
                            type="number"
                            value={this.state.optionalCoursesNumberMax}
                            onChange={(e) => this.setState({ optionalCoursesNumberMax: e.target.value })}
                            name="optionalCoursesNumberMax"
                            placeholder="Unesite maksimalan broj izbornih predmeta"
                            min={1}
                        />
                    </Form.Group>

                    <Button
                        color="blue"
                        size="small"
                        onClick={() => this.saveSemesterInfo(
                            this.state.optionalCoursesECTSMin,
                            this.state.optionalCoursesECTSMax,
                            this.state.optionalCoursesNumberMin,
                            this.state.optionalCoursesNumberMax
                        )}

                    >  Sačuvaj
                    </Button>
                </Form>
                <ToastContainer hideProgressBar />
            </Segment>
        );
    }
}

export default SemesterInfo;



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgramImplementation/SemesterInfo.js